import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import { logEvent } from "../../utils/Analytics";
import { ActionButtonProps, MENUS, MenuProps } from "./Menu";
import { Quantifiction } from "./Quantifiction";

export interface Props {
  onClose: () => void;
  open: boolean;
}

export const SideBar = (props: Props) => {
  const { open, onClose } = props;

  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      variant="temporary"
      open={open}
    >
      <Box height="100%">
        <Box my={4} mx={2}>
          <Quantifiction size="small" />
        </Box>
        <Box my={2} width={240}>
          <List>
            {MENUS.map((m) => (
              <MobileMenu {...m} />
            ))}
          </List>
          <Box mt={2}>
            <ActionButton
              label="Login"
              variant="outlined"
              href="https://app.quantifiction.com/login"
              eventName="login"
            />
            <ActionButton
              label="Signup"
              variant="contained"
              href="https://app.quantifiction.com/signup"
              eventName="sign_up"
            />
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

const ActionButton = (props: ActionButtonProps) => {
  const { href, label, eventName, variant } = props;

  return (
    <Box mx={1} mt={1}>
      <Button
        variant={variant ?? "outlined"}
        color="primary"
        size="medium"
        href={href}
        fullWidth={true}
        onClick={() => logEvent(eventName)}
      >
        {label}
      </Button>
    </Box>
  );
};

const MobileMenu = (props: MenuProps) => {
  const { label, to, items, eventName } = props;
  const [open, setOpen] = React.useState(false);

  if (!!to) {
    return (
      <ListItem
        button={true}
        component={RouterLink}
        to={to}
        onClick={() => {
          if (eventName) {
            logEvent(eventName);
          }
        }}
      >
        <ListItemText primary={label} />
      </ListItem>
    );
  }

  return (
    <>
      <ListItem button={true} selected={open} onClick={() => setOpen(!open)}>
        <ListItemText primary={label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit={true}>
        <Box ml={2}>
          <List>
            {items?.map((i) =>
              !!i ? (
                <ListItem button={true} component={RouterLink} to={i.to}>
                  <ListItemText primary={i.label} color="textSecondary" />
                </ListItem>
              ) : undefined
            )}
          </List>
        </Box>
      </Collapse>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/SideBar.tsx